const directorySeparator = '/';
const backslashRegExp = /\\/g;
export function normalizePath(path) {
    return path.replace(backslashRegExp, directorySeparator);
}

//# sourceMappingURL=normalizePath.js.map
